import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { sessionQueries } from '@/api';
import { LoginPage } from '@/features/auth/login-page';

/**
 * `verified=1` ставить бекенд, редіректячи сюди з листа підтвердження.
 * `redirect` памʼятає, куди користувач ішов до входу — спека вимагає
 * повернути його на ту саму картку авто (§4).
 */
const loginSearchSchema = z.object({
	verified: z.coerce.boolean().optional(),
	redirect: z.string().optional(),
	/** Ставить бекенд, коли посилання з листа недійсне або прострочене. */
	error: z.string().optional(),
});

export const Route = createFileRoute('/login')({
	validateSearch: loginSearchSchema,
	/**
	 * Автентифікованому тут робити нічого. Перевіряємо саме тут, а не в
	 * компоненті: інакше форма встигла б промалюватись і зникнути.
	 */
	beforeLoad: async ({ context, search }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (session) throw redirect({ to: search.redirect ?? '/dashboard' });
	},
	component: LoginPage,
	staticData: { fullScreen: true },
});
